import React, { useState } from "react";
import styles from "../styles/communitySearchBox.module.css";
import Mandala from "@public/assets/icons/mandala.svg";
import SearchIcon from "@mui/icons-material/Search";
import { useTranslation } from "react-i18next";
const SearchBox = ({
  setSearchData,
  setCommunityPage,
  setHasMoreCommunities,
  debounced
}) => {
  const {
    t
  } = useTranslation();
  const [search, setSearch] = useState("");
  function setSearchValue(data) {
    setSearch(data);
    setSearchData(data);
    setCommunityPage(0);
    setHasMoreCommunities(true);
  }
  return <div className={styles.searchHeaderContainer} data-sentry-component="SearchBox" data-sentry-source-file="communitySearchBox.jsx">
      <div className={styles.searchHeader}>
        <div className={styles.leftMandalaDiv}>
          <div className={styles.leftMandala}>
            <Mandala data-sentry-element="Mandala" data-sentry-source-file="communitySearchBox.jsx" />
          </div>
        </div>
        <div className={styles.rightMandalaDiv}>
          <div className={styles.rightMandala}>
            <Mandala data-sentry-element="Mandala" data-sentry-source-file="communitySearchBox.jsx" />
          </div>
        </div>
        <div className={styles.searchInner}>
          <div className={styles.communityHeading}>
            {t("welcome-to")}
            <span>{t("mandir")}</span>
            {t("communities")}
          </div>
          <div className={styles.searchBox}>
            <span className={styles.searchIcon}>
              <SearchIcon data-sentry-element="SearchIcon" data-sentry-source-file="communitySearchBox.jsx" />
            </span>
            <input type="text" placeholder={`${t("search-for")} ${t("mahalaxmi-mandir-kolhapur")}`} className={styles.searchInput} value={search} onChange={e => {
            setSearchValue(e.target.value);
            debounced(e.target.value);
          }} />
          </div>
          <div className={styles.popularSearchContainer}>
            <div className={styles.popularSearch}>{t("popular-searches")}</div>
            <div className={styles.searchSuggestion} onClick={() => setSearchValue("Bankey Bihari")}>
              {t("bankey-bihari")}{" "}
            </div>
            <div className={styles.searchSuggestion} onClick={() => setSearchValue("Kashi")}>
              {t("kashi")}{" "}
            </div>
            <div className={styles.searchSuggestion} onClick={() => setSearchValue("Mangalnath")}>
              {t("mangalnath")}
            </div>
          </div>
        </div>
      </div>
    </div>;
};
export default SearchBox;